import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import moment from 'moment';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { ServiceintervalDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceinterval-dto';
import { ServiceintervalChartItem } from 'src/app/components/aftale/models';
import { GraphService } from 'src/app/services/graph.service';

@Component({
    selector: 'app-serviceinterval-change-graph',
    templateUrl: './serviceinterval-change-graph.component.html',
    styleUrls: ['./serviceinterval-change-graph.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServiceintervalChangeGraphComponent implements OnInit {
  @Input() headline1: string;
  @Input() headline2: string;

  _naesteEftersynDate: Date;

  get naesteEftersynDate(): Date {
    return this._naesteEftersynDate;
  }
  @Input() set naesteEftersynDate(value: Date) {
    this._naesteEftersynDate = value;
    this.update();
  }

  _opkraevningDate: Date;

  get opkraevningDate(): Date {
    return this._opkraevningDate;
  }
  @Input() set opkraevningDate(value: Date) {
    this._opkraevningDate = value;
    this.update();
  }

  _serviceinterval1: ServiceintervalDto;

  get serviceinterval1(): ServiceintervalDto {
    return this._serviceinterval1;
  }
  @Input() set serviceinterval1(value: ServiceintervalDto) {
    this._serviceinterval1 = value;
    if (value) {
      this.update();
    }
  }

  _serviceaftale: ServiceaftaleDto;

  get serviceaftale(): ServiceaftaleDto {
    return this._serviceaftale;
  }
  @Input() set serviceaftale(value: ServiceaftaleDto) {
    this._serviceaftale = value;
    if (value) {
      this.update();
    }
  }

  _serviceinterval2: ServiceintervalDto;

  get serviceinterval2(): ServiceintervalDto {
    return this._serviceinterval2;
  }
  @Input() set serviceinterval2(value: ServiceintervalDto) {
    this._serviceinterval2 = value;
    if (value) {
      this.update();
    }
  }

  offset1: number;
  offset2: number;
  months1: ServiceintervalChartItem[];
  months2: ServiceintervalChartItem[];
  onset1: ServiceintervalChartItem[];
  onset2: ServiceintervalChartItem[];

  ddOffsetPx: string;

  constructor(private graph: GraphService) {}

  ngOnInit(): void {}

  update() {
    if (!this.serviceinterval1 || !this.serviceinterval2 || !this.serviceaftale) return;

    const classes = [
      { date: new Date(this.serviceaftale?.startDate), class: 'startDate', comment: 'Startdato' },
      { date: new Date(this.serviceaftale?.endDate), class: 'endDate', comment: 'Opsigelsesdato' },
    ];

    this.serviceinterval1?.opkraevningDateList?.map((x) =>
      classes.push({
        date: new Date(x),
        class: 'opkraevning',
        comment: 'Opkrævning',
      })
    );

    this.serviceinterval1?.eftersynDateList?.map((x) =>
      classes.push({
        date: new Date(x.deadline),
        class: 'eftersyn',
        comment: 'Eftersyn',
      })
    );

    this.serviceinterval1?.kommendeEftersynDateList?.map((x) =>
      classes.push({
        date: new Date(x),
        class: 'naesteEftersynDate',
        comment: 'Kommende eftersyn',
      })
    );

    this.serviceinterval1?.kommendeOpkraevningerDateList?.map((x) =>
      classes.push({
        date: new Date(x),
        class: 'opkraevningDate',
        comment: 'Kommende opkrævning',
      })
    );

    this.months1 = this.graph.getRange(new Date(this.serviceinterval1.startDate), new Date(this.serviceinterval1.endDate), classes);

    this.months2 = this.graph.getRange(new Date(this.serviceinterval2.startDate), new Date(this.serviceinterval2.endDate), classes);

    this.offset1 = 0;

    this.offset2 = this.graph.getRange(new Date(this.serviceinterval1.startDate), new Date(this.serviceinterval2.startDate), []).length - 1;

    this.onset1 = [];
    this.onset2 = [];

    if (moment(new Date(this.serviceinterval1.startDate)).diff(new Date(this.serviceinterval2.startDate), 'days') != 0) {
      this.months1 = this.graph.getRange(new Date(this.serviceinterval1.startDate), new Date(this.serviceinterval2.startDate), classes);

      this.onset1 = this.graph.getRange(new Date(this.serviceinterval2.startDate), new Date(this.serviceinterval1.endDate), classes);
    }

    const dd = this.graph.getRange(new Date(this.serviceinterval1.startDate), new Date(), []);
    this.ddOffsetPx = dd.length * 16 + 85 + 'px';
  }
}
